<app-flow-action-card icon="remove_circle" iconColor="text-red-600" label="Stop interactie" />
